import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/de'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://ac889f3959dc4ad998916017c5b76918@sentry.io/1777776',
  integrations: [new Integrations.Vue({ Vue, attachProps: false })]
})

Vue.use(ElementUI, { locale })
Vue.use(firebase)

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyD-3FXheqMiBBioG0W-qNeY8ufZUhwME4U',
  authDomain: 'klingelplatten-360service.firebaseapp.com',
  databaseURL: 'https://klingelplatten-360service.firebaseio.com',
  projectId: 'klingelplatten-360service',
  storageBucket: '',
  messagingSenderId: '638690495260',
  appId: '1:638690495260:web:00fa7287634a84f7ca48d9'
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

let app

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
